import moment from 'moment-timezone';

import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('payment');
const ARPPROVE_LX_PAYMENT = define('ARPPROVE_LX_PAYMENT', true);
const HOLD_PAYMENT = define('HOLD_PAYMENT', true);
const GET_PAYOUT_LIST = define('GET_PAYOUT_LIST', true);
const PAID_BILL = define('PAID_BILL', true);
const GET_STATEMENT = define('GET_STATEMENT', true);
const GET_REFUNDS = define('GET_REFUNDS', true);
const APPROVE_REFUND = define('APPROVE_REFUND', true);
const VOID_REFUND = define('VOID_REFUND', true);
const GET_HISTORY = define('GET_HISTORY', true);
const DOWNLOAD_MANUAL_PAYMENT_FILE = define('DOWNLOAD_MANUAL_PAYMENT_FILE', true);

const initialState = {
  isLoadingPayoutList: true,
  payoutList: [],
  isLoadingStatement: true,
  statements: [],
  isLoadingRefund: true,
  refunds: [],
  isLoadingHistory: true,
  history: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYOUT_LIST.RESOLVED:
      return {
        ...state,
        isLoadingPayoutList: false,
        payoutList: action.data
      };
    case GET_STATEMENT.PENDING:
      return {
        ...state,
        isLoadingStatement: true
      };
    case GET_STATEMENT.RESOLVED:
      return {
        ...state,
        isLoadingStatement: false,
        statements: action.data
      };
    case GET_REFUNDS.PENDING:
      return {
        ...state,
        isLoadingRefund: true
      };
    case GET_REFUNDS.RESOLVED:
      return {
        ...state,
        isLoadingRefund: false,
        refunds: action.data
      };
    case GET_HISTORY.PENDING:
      return {
        ...state,
        isLoadingHistory: true
      };
    case GET_HISTORY.RESOLVED:
      return {
        ...state,
        isLoadingHistory: false,
        history: action.data
      };
    default: return state;
  }
};

export const actions = {
  approvedLxPayment: id => ({
    type: ARPPROVE_LX_PAYMENT,
    promise: api.post(`/payments/${id}/approve`),
    success: 'LX Payment has been approved',
    error: 'Unable to approve LX payment'
  }),
  holdPayment: id => ({
    type: HOLD_PAYMENT,
    promise: api.post(`/bookings/${id}/admin/hold-payment`, { is_hold: true }),
    success: 'LX Payment has been holded',
    error: 'Unable to hold LX payment'
  }),
  unholdPayment: id => ({
    type: HOLD_PAYMENT,
    promise: api.post(`/bookings/${id}/admin/hold-payment`, { is_hold: false }),
    success: 'LX Payment has been unholded',
    error: 'Unable to unhold LX payment'
  }),
  getPayoutList: () => ({
    type: GET_PAYOUT_LIST,
    promise: api.get('/payments/bills'),
    error: 'Unable to load payout list'
  }),
  paidBill: hash => ({
    type: PAID_BILL,
    promise: api.post(`/payments/${hash}/paid-bill`),
    success: `${hash} has been paid`,
    error: 'Unable to paid bill'
  }),
  getStatement: (from = moment().add(-1, 'month').format('YYYY-MM-DD'), to = moment().format('YYYY-MM-DD'), lx) => ({
    type: GET_STATEMENT,
    promise: api.get(`/payments/statement?from=${from}&to=${to}${lx ? `&user_id=${lx}` : ''}`),
    error: 'Unable to load statement'
  }),
  getRefund: () => ({
    type: GET_REFUNDS,
    promise: api.get('/refunds/pending'),
    error: 'Unable to get pending refund'
  }),
  approveRefund: refundId => ({
    type: APPROVE_REFUND,
    promise: api.post(`/refunds/${refundId}/approve`),
    success: 'Refund has been approved',
    error: 'Unable to approve refund'
  }),
  voidRefund: refundId => ({
    type: VOID_REFUND,
    promise: api.delete(`/refunds/${refundId}/void`),
    success: 'Refund has been voided',
    error: 'Unable to void refund'
  }),
  getHistory: (from = moment().add(-1, 'month').format('YYYY-MM-DD'), to = moment().format('YYYY-MM-DD')) => ({
    type: GET_HISTORY,
    promise: api.get(`/payments/history?from=${from}&to=${to}`),
    error: 'Unable to load payment history'
  }),
  downloadManualPaymentFile: (date, users) => ({
    type: DOWNLOAD_MANUAL_PAYMENT_FILE,
    promise: api.post('/files/kbank/manual', { date, users }),
    success: 'Downloaded',
    error: 'Unable to load a file'
  })
};



// WEBPACK FOOTER //
// ./src/ducks/payment.js